import AuthProvider from "./AuthProvider";

export default AuthProvider;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/authentication/AuthProvider/index.tsx